<template>
    <div>
        <Header :goBack=true></Header>
        <div id="ms_scroll">
            <div class="ms_scroll_wrap">
                <Scroll ref="scroll" :scrollbar="scrollbarObj" :listenScroll="listenScroll" :pullDownRefresh="pullDownRefreshObj" :pullUpLoad="pullUpLoadObj" :startY="parseInt(startY)" @pullingDown="onPullingDown" @pullingUp="onPullingUp" @scroll="onScroll">
                    <!-- <div class="ms_banner" v-if="bannerImgUrl"><img :src="bannerImgUrl" alt=""></div> -->
                    <div class="ms_banner"><img src="../images/gaikuojian_banner-app@2x.png" alt=""></div>
                    <div :class="['ms_navbar',navBarFixed?'navbar_fixed':'']">
                        <ul ref="tabList">
                            <router-link tag="li" v-for="(item,index) in navBarList" :key="index" ref="tabItem" :class="['item_wrap',$route.path.indexOf(item.key)!==-1?'active':'',item.icon&&(iconDirection==='v'?'icon_vertical':'icon_horizontal')]" :to="item.url" :replace="index>1?true:''">
                                <div class="nav_icon" v-if="item.icon" :style="iconStyle">
                                    <img :src="$route.path.indexOf(item.key)!==-1?item.activeIcon:item.icon" alt="">
                                </div>
                                <span>{{item.title}}</span>
                            </router-link>
                        </ul>
                    </div>
                    <div :class="['ms_content',navBarFixed?'margin_top':'']">
                        <slot></slot>
                    </div>
                </Scroll>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "home",
    data() {
        return {
            scrollbar: false,
            scrollbarFade: true,
            listenScroll: true,
            // pullDownRefresh: true, //下拉刷新
            pullDownRefreshThreshold: 90,
            pullDownRefreshStop: 40,
            pullDownRefreshTxt: this.$t("common.refreshed"),//刷新成功
            // pullUpLoad: true, //加载更多
            pullUpLoadThreshold: 0,
            pullUpLoadMoreTxt: this.$t("common.LoadMore"),//加载更多
            pullUpLoadNoMoreTxt: this.$t("common.noMore"), //没有更多数据了
            startY: 0,
            scrollToX: 0,
            scrollToY: -200,
            scrollToTime: 700,
            scrollToEasing: "bounce",
            scrollToEasingOptions: ["bounce", "swipe", "swipeBounce"],
            navBarFixed: false
        };
    },
    props: {
        pullDownRefresh: {
            type: null,
            default: false
        },
        pullUpLoad: {
            type: null,
            default: false
        },
        bannerImgUrl: {
            type: String
        },
        navBarList: {
            type: Array,
            default() {
                return [];
            }
        },
        iconDirection: {
            type: String,
            default: "h" //默认水平
        },
        iconStyle: {
            type: String,
            default: "height: 1.25rem"
        }
    },
    mounted() {},
    destroyed() {},
    components: {},
    watch: {
        scrollbarObj: {
            handler() {
                this.rebuildScroll();
            },
            deep: true
        },
        pullDownRefreshObj: {
            handler() {
                this.rebuildScroll();
            },
            deep: true
        },
        pullUpLoadObj: {
            handler() {
                this.rebuildScroll();
            },
            deep: true
        },
        startY() {
            this.rebuildScroll();
        }
    },
    computed: {
        scrollbarObj: function() {
            return this.scrollbar ? { fade: this.scrollbarFade } : false;
        },
        pullDownRefreshObj: function() {
            return this.pullDownRefresh
                ? {
                      threshold: parseInt(this.pullDownRefreshThreshold),
                      stop: parseInt(this.pullDownRefreshStop),
                      txt: this.pullDownRefreshTxt
                  }
                : false;
        },
        pullUpLoadObj: function() {
            return this.pullUpLoad
                ? {
                      threshold: parseInt(this.pullUpLoadThreshold),
                      txt: {
                          more: this.pullUpLoadMoreTxt,
                          noMore: this.pullUpLoadNoMoreTxt
                      }
                  }
                : false;
        }
    },
    methods: {
        scrollTo() {
            this.$refs.scroll.scrollTo(
                this.scrollToX,
                this.scrollToY,
                this.scrollToTime,
                ease[this.scrollToEasing]
            );
        },
        onPullingDown() {
            // console.log("下拉刷新");
            // this.$refs.scroll.forceUpdate();
            this.$emit("pullingDown");
        },
        onPullingUp() {
            // 更新数据
            // console.log("加载更多");
            // this.$refs.scroll.forceUpdate();
            this.$emit("pullingUp");
        },
        onScroll(pos) {
            var bannerHeight = document
                .querySelector(".ms_banner")
                .getBoundingClientRect().height;
            var navbar = document.querySelector(".ms_navbar");
            var navOffsetTop = navbar.offsetTop;
            if (Math.abs(pos.y) >= bannerHeight + 10) {
                this.navBarFixed = true;
                navbar.style.top = Math.abs(pos.y) - 10 + "px";
            } else {
                this.navBarFixed = false;
            }
        },
        forceUpdate() {
            this.$nextTick(() => {
                this.$refs.scroll.forceUpdate();
            });
        },
        rebuildScroll() {
            this.$nextTick(() => {
                this.$refs.scroll.destroy();
                this.$refs.scroll.initScroll();
            });
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../style/mixin.scss";
#ms_scroll {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 50px;
    background-color: #f3f5f9;
    .ms_scroll_wrap {
        height: 100%;
        position: relative;
        transform: rotate(0deg);
        overflow: hidden;
    }
    .ms_banner {
        width: 100%;
        height: 9.5rem /* 152/16 */;
        img {
            width: 100%;
            vertical-align: middle;
        }
    }
    .navbar_fixed {
        position: fixed;
        top: 3.125rem /* 50/16 */;
        z-index: 999;
        width: 100%;
        transform: translateZ(0);
        -webkit-transform: translateZ(0);
    }
    .ms_navbar {
        margin: 0.625rem /* 10/16 */ 0;
        box-shadow: 0 -0.125rem /* 2/16 */ 0.625rem /* 10/16 */ rgb(219, 209, 214);
        ul {
            width: 100%;
            display: flex;
            > li {
                flex: 1;
                width: 0;
                color: #666666;
                text-align: center;
                padding: 0.625rem /* 10/16 */ 0.3125rem /* 5/16 */;
                background-color: #ffffff;
                box-shadow: 0 0.125rem /* 2/16 */ 0.625rem /* 10/16 */
                    rgb(219, 209, 214);
                box-sizing: border-box;
                &.active {
                    background-color: #edaa42;
                    color: #ffffff;
                }
                //有图标时
                img {
                    width: auto;
                    height: auto;
                    max-width: 100%;
                    max-height: 100%;
                    vertical-align: top;
                }
                span {
                    display: inline-block;
                    font-weight: bold;
                    font-size: 0.875rem /* 14/16 */;
                    line-height: 1;
                    letter-spacing: 0;
                    word-spacing: 0;
                }
                // 水平
                &.icon_horizontal {
                    min-height: 3.9375rem /* 63/16 */;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .nav_icon {
                        flex-shrink: 0;
                        margin-right: 0.3125rem /* 5/16 */;
                    }
                }
                // 垂直
                &.icon_vertical {
                    // flex-direction: column;
                    // align-items: center;
                    .nav_icon {
                        margin-bottom: 0.3125rem /* 5/16 */;
                    }
                }
                
            }
        }
        // ul {
        //     width: 100%;
        //     display: flex;
        //     box-sizing: border-box;
        //     > li {
        //         flex: 1;
        //         position: relative;
        //         display: flex;
        //         justify-content: center;
        //         align-items: center;
        //         text-align: center;
        //         background-color: #ffffff;
        //         box-shadow: 0 0.125rem /* 2/16 */ 0.625rem /* 10/16 */
        //             rgb(219, 209, 214);
        //         font-size: 0.75rem /* 12/16 */;
        //         color: #666666;
        //         span {
        //             max-width: 3.75rem /* 60/16 */;
        //         }
        //         &.active {
        //             background-color: #edaa42;
        //             color: #ffffff;
        //         }
        //         img {
        //             width: 0.9375rem /* 15/16 */;
        //             vertical-align: middle;
        //         }
        //         &:nth-child(3) {
        //             img {
        //                 width: 0.6875rem /* 11/16 */;
        //             }
        //         }
        //         // 垂直
        //         &.icon_vertical {
        //             height: 4.375rem /* 70/16 */;
        //             flex-direction: column;
        //             align-items: center;
        //             img {
        //                 margin-bottom: 1.125rem /* 18/16 */;
        //             }
        //             span {
        //                 position: absolute;
        //                 bottom: 0.3125rem /* 5/16 */;
        //             }
        //         }
        //         // 水平
        //         &.icon_horizontal {
        //             height: 3.75rem /* 60/16 */;
        //             img {
        //                 margin-right: 0.3125rem /* 5/16 */;
        //             }
        //         }
        //     }
        // }
    }
    .margin_top {
        margin-top: 4.375rem /* 70/16 */;
    }
    .ms_content {
        background-color: #f3f5f9;
        .ms_card {
            padding: 0.625rem /* 10/16 */;
            background-color: #ffffff;
            box-shadow: 0 0 0.3125rem /* 5/16 */ #f3f5f9;
            img {
                width: 100%;
                margin: 0.625rem /* 10/16 */ 0;
            }
        }
    }
}
</style>


